import React from 'react';
import { Container } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = (theme) => ({
  page: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    background: `
      linear-gradient(
        180deg,
        ${theme.palette.primary.main}10 0%,
        ${theme.palette.background.default} 40%,
        ${theme.palette.background.default} 100%
      )
    `,
  },
  shell: {
    width: '100%',
    maxWidth: 600,
    margin: '0 auto',
  },
});

function AuthPageLayout({ classes, children }) {
  return (
    <div className={classes.page}>
      <Container className={classes.shell}>{children}</Container>
    </div>
  );
}

export default withStyles(styles)(AuthPageLayout);
